/**
 * Used for marking the status of various endpoint connections
 */

export const ENDPOINT_CONNECT_STATUS_STORAGE_KEY =
  'xm.endpoints-connect-status';
export const ENDPOINT_CONNECT_STATUSES = {
  NONE: 'NONE',
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  FAILED: 'FAILED',
};
